import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { ReactNode } from 'react';

interface FormInputProps {
  id: string;
  label: string;
  type?: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  icon: ReactNode;
  rightIcon?: ReactNode;
  disabled?: boolean;
  required?: boolean;
}

/**
 * Styled form input component for authentication pages
 * Matches Atlas Restoration Figma design with:
 * - Red left icon
 * - Optional right icon (e.g., password visibility toggle)
 * - Consistent sizing and spacing
 * - Custom placeholder color
 */
export function FormInput({
  id,
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  icon,
  rightIcon,
  disabled = false,
  required = false,
}: FormInputProps) {
  return (
    <div className="space-y-1">
      <Label htmlFor={id} className="text-[20px] font-semibold text-black">
        {label}
      </Label>
      <div className="relative">
        <div className="absolute left-[17px] top-1/2 -translate-y-1/2 text-primary">
          {icon}
        </div>
        <Input
          id={id}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="h-[45px] rounded-[20px] border-[1.5px] border-[#b3b3b3] pl-[60px] pr-[50px] text-[16px] placeholder:text-[#878787]"
          disabled={disabled}
          required={required}
        />
        {rightIcon && (
          <div className="absolute right-[17px] top-1/2 -translate-y-1/2">
            {rightIcon}
          </div>
        )}
      </div>
    </div>
  );
}
